import { render, staticRenderFns } from "./D.vue?vue&type=template&id=450f9af8&scoped=true"
import script from "./D.vue?vue&type=script&lang=js"
export * from "./D.vue?vue&type=script&lang=js"
import style0 from "./D.vue?vue&type=style&index=0&id=450f9af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f9af8",
  null
  
)

export default component.exports